module.exports = __webpack_public_path__ + "img/teacherTrain-1.0f914b76.jpg";